export default __webpack_public_path__ + "static/media/test-approved.eacd9b44.png";